import { observer } from 'mobx-react-lite';
import IconImages from '@shared/assets/images/icons';
import { useStore } from '@shared/hooks/useStore';

interface ReaderToolbarProps {
    zoom: number,
    multiplier: number,
    onZoomIn: () => void,
    onZoomOut: () => void,
    isPreview: boolean,
    minMultiplier: number,
    maxMultiplier: number
}

const ReaderToolbar = observer(({
    zoom,
    multiplier,
    onZoomIn,
    onZoomOut,
    isPreview,
    minMultiplier,
    maxMultiplier
}: ReaderToolbarProps) => {
    const { readerStore } = useStore();
    const hasActiveBook = !!readerStore.getActiveBook();

    const getZoomButtonClass = (disabled: boolean) => {
        const base = 'p-1 transition-colors';
        return disabled ?
            `${base} text-gray-600 cursor-not-allowed opacity-50` :
            `${base} text-white`;
    };

    const getButtonClass = (disabled: boolean, isActive?: boolean) => {
        const base = 'p-1 rounded transition-colors';
        if (disabled) {
            return `${base} text-gray-600 cursor-not-allowed opacity-50`;
        }
        return `${base} text-white ${isActive ? 'bg-[#FFFFFF1A]' : ''}`;
    };

    return (
        <div className='flex items-center gap-1 sm:gap-4'>
            {!isPreview && (
                <>
                    <button
                        onClick={() => readerStore.toggleSearch()}
                        disabled={!hasActiveBook}
                        className={getButtonClass(!hasActiveBook, readerStore.isSearchOpen)}
                        title='検索'
                    >
                        <img src={IconImages.magnifyingGlassIc} alt='検索' className='size-6' />
                    </button>

                    <button
                        onClick={() => readerStore.toggleBookmarkNote()}
                        disabled={!hasActiveBook}
                        className={getButtonClass(!hasActiveBook, readerStore.isBookmarkNoteOpen)}
                        title='ブックマークとノート'
                    >
                        <img src={IconImages.listIc} alt='ブックマークとノート' className='size-6' />
                    </button>

                    <button
                        onClick={() => readerStore.handleBookmark()}
                        disabled={!hasActiveBook}
                        className={getButtonClass(!hasActiveBook)}
                        title='ブックマーク'
                    >
                        <img src={readerStore.isPageBookmarked ? IconImages.bookmarkSimpleActiveIc : IconImages.bookmarkSimpleIc} alt='ブックマーク' className='size-6' />
                    </button>
                </>

            )}

            <button
                onClick={onZoomOut}
                disabled={!hasActiveBook || multiplier <= minMultiplier}
                className={getZoomButtonClass(!hasActiveBook || multiplier <= minMultiplier)}
                title='縮小'
            >
                <img src={IconImages.minusCircleIc} alt='縮小' className='size-6' />
            </button>

            <button
                onClick={onZoomIn}
                disabled={!hasActiveBook || multiplier >= maxMultiplier}
                className={getZoomButtonClass(!hasActiveBook || multiplier >= maxMultiplier)}
                title='拡大'
            >
                <img src={IconImages.plusCircleIc} alt='拡大' className='size-6' />
            </button>
        </div>
    );
});

export default ReaderToolbar;
